import ListaPreciosVentaDelete from "./ListaPreciosVentaDelete.vue";
export default ListaPreciosVentaDelete;
